import React from "react";
import MDTypography from "materialDashboard/components/MDTypography";


const FormSubSectionTitle = ({ title }) => {
    return (
        <MDTypography fontWeight="bold" variant="body2" color="text" textTransform="capitalize">
            {title}
        </MDTypography>
    );
}

export default FormSubSectionTitle;